import React from 'react';
import { useNavigate } from 'react-router-dom';

import useGetUserMenuLinks from '../routes/useGetUserMenuLinks';

// Canonical "main" path. Kept as an export because useRequest imports it to recognise
// main-page requests, and it is the fallback landing for a user with no permitted menu link.
export const mainPage = '/members';

const Home: React.FC = () => {
    const navigate = useNavigate();
    const menuLinks = useGetUserMenuLinks();

    React.useEffect(() => {
        // [HWM-22934] Land on the first page the user's role actually permits rather than
        // hard-navigating everyone to /members. A leads-only role (e.g. Onboarding Specialist)
        // has Members hidden in its nav; sending it to /members produced a fleet-permission 403
        // that useRequest escalated into a forced logout.
        const firstAllowed = menuLinks.find((link) => link.show);
        // replace: true — this is a landing redirect, so don't leave `/` on the history stack
        // (Back would bounce the user right back into this effect and redirect again).
        navigate(firstAllowed?.to ?? mainPage, { replace: true });
    }, [navigate, menuLinks]);

    return null;
};

export default Home;
